import { EmploymentType as SeoEmploymentType } from 'next-seo/lib/jsonld/jobPosting';

import { EmploymentType } from '@pflegia/types/api/candidate/employment-type';

export const mapSeoEmploymentType = (employmentType: EmploymentType): SeoEmploymentType => {
  switch (employmentType) {
    case EmploymentType.FullTime:
      return 'FULL_TIME';

    case EmploymentType.PartTime:
      return 'PART_TIME';

    default:
      return 'OTHER';
  }
};
